/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { TypeOfAnaesthesia } from 'app/shared/model/enumerations/type-of-anaesthesia.model';
import { ASACategory } from 'app/shared/model/enumerations/asa-category.model';

export interface IPreOpReviewPAC {
  id?: string;
  notes?: string | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  fitForProcedure?: boolean;
  recomendedTypeOfAnaesthesia?: keyof typeof TypeOfAnaesthesia | null;
  asaCategory?: keyof typeof ASACategory | null;
  surgery?: IPatientProcedure;
  reviewedBy?: IDoctor;
}

export const defaultValue: Readonly<IPreOpReviewPAC> = {
  active: false,
  fitForProcedure: false,
};
